<template>
  <div>
    <div class="flow">
      <div class="flow-title">
        <h3>{{ title }}</h3>
      </div>
      <div class="flow-contents">
        <h4>{{ contentTitle }}</h4>
        <p>{{ content }}</p>
      </div>
    </div>
    <div v-if="arrowFlg" class="flow-arrow">
      <img src="@/assets/20240508ecocreen_top_trai.webp" alt="次のステップ">
    </div>
  </div>
</template>

<script>
export default {
  name: "StepContent",
  props: {
    title: String,
    contentTitle: String,
    content: String,
    arrowFlg: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.flow {
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    display: block;
  }
  .flow-title {
    width: 20%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--main);
    @media screen and (max-width: 767px) {
      width: 100%;
    }
    h3 {
      font-size: 23px;
      font-weight: 500;
      color: var(--white);
      @media screen and (max-width: 767px) {
        font-size: 16px;
      }
    }
  }
  .flow-contents {
    width: 77%;
    @media screen and (max-width: 767px) {
      display: block;
      width: 100%;
      margin-top: 10px;
    }
    h4 {
      font-size: 20px;
      font-weight: 500;
      color: var(--main);
      text-align: start;
      margin-top: 0;
      margin-bottom: 12px;
      @media screen and (max-width: 767px) {
        font-size: 18px;
        text-align: center;
      }
    }
    p {
      font-size: 18px;
      font-weight: 500;
      @media screen and (max-width: 767px) {
        line-height: 1.5rem;
        font-size: 16px;
        margin-bottom: 5px;
      }
    }
  }
}
.flow-arrow {
  width: 20%;
  text-align: center;
  margin: 5px 0;
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 20px;
  }
  img {
    width: 30%;
    margin: auto;
    @media screen and (max-width: 767px) {
      width: 25%;
      margin: 10px auto;
    }
  }
}
</style>
